import { Typography } from '@breetometer/components';
import type { ReactNode } from 'react';

const TransactionDetailsRowLeft = ({ children, label }: { children?: ReactNode; label?: string }) => (
	<div className='transaction-details_content_row_left'>
		{label ? <Typography className='transaction-details_content_row_label color-primary-50'>{label}</Typography> : children}
	</div>
);

export default TransactionDetailsRowLeft;
